module.exports = __webpack_public_path__ + "static/img/calendar-example.8c2b610.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/calendar-example.png
// module id = oyJS
// module chunks = 1